const API_BASE = process.env.REACT_APP_API_BASE_URL ?? "http://localhost:8080";

export function getToken(): string | null {
  return localStorage.getItem("token");
}

export function setToken(token: string) {
  localStorage.setItem("token", token);
}

export function clearToken() {
  localStorage.removeItem("token");
}

type Method = "GET" | "POST" | "PUT" | "DELETE";

export async function api<T>(
  path: string,
  method: Method = "GET",
  body?: unknown,
  auth: boolean = false
): Promise<T> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (auth) {
    const token = getToken();
    if (!token) throw new Error("Not logged in");
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    if (res.status === 401) {
        clearToken();
        // Optional: Trigger a redirect or event
    }
    const text = await res.text();
    throw new Error(text || `Request failed: ${res.status}`);
  }

  // Some endpoints may return empty body
  const contentType = res.headers.get("content-type");
  if (contentType && contentType.includes("application/json")) {
    return (await res.json()) as T;
  }
  return {} as T;
}
